import { Crown, Lock } from "lucide-react";
import { useLang } from "@/context/LangContext";

const Stat = ({ label, value, testId, gold }) => (
  <div>
    <p className="text-xs font-semibold uppercase tracking-widest text-white/50">{label}</p>
    <p className={`mt-1 font-extrabold ${gold ? "text-3xl text-amber-300 sm:text-4xl" : "text-lg text-white"}`} data-testid={testId}>{value}</p>
  </div>
);

export const RewardsOverview = ({ user, pkg }) => {
  const { t, tr } = useLang();
  const since = user.approved_at || user.payment_submitted_at || user.created_at;
  return (
    <div className="relative overflow-hidden rounded-2xl bg-[#07090A] p-6 text-white" data-testid="dashboard-rewards-overview">
      <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-amber-500/20 blur-3xl" />
      <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-amber-300"><Crown className="h-4 w-4" />{t("rewards_title")}</p>
      <p className="mt-2 text-xl font-bold" data-testid="dashboard-package-name">{pkg ? tr(pkg.name) : user.package_id}</p>
      <div className="mt-6 space-y-5">
        <Stat label={t("reward_amount")} value={pkg?.reward || "—"} testId="dashboard-reward-amount" gold />
        <div className="grid grid-cols-2 gap-4">
          <Stat label={t("amount_paid")} value={pkg?.price || "—"} testId="dashboard-amount-paid" />
          <Stat label={t("active_since")} value={new Date(since).toLocaleDateString()} testId="dashboard-active-since" />
        </div>
      </div>
    </div>
  );
};

export const PackageSummary = ({ user, pkg }) => {
  const { t, tr } = useLang();
  return (
    <div className="space-y-5 rounded-2xl border border-border bg-card p-6" data-testid="dashboard-package-summary">
      <div>
        <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">{t("package")}</p>
        <p className="mt-2 text-2xl font-extrabold" data-testid="dashboard-package-name">{pkg ? tr(pkg.name) : user.package_id}</p>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div><p className="text-xs text-muted-foreground">{t("reward")}</p><p className="font-extrabold text-amber-600 dark:text-amber-400" data-testid="dashboard-package-reward">{pkg?.reward}</p></div>
        <div><p className="text-xs text-muted-foreground">{t("reg_payment")}</p><p className="font-extrabold text-primary" data-testid="dashboard-package-price">{pkg?.price}</p></div>
      </div>
      <div className="flex items-start gap-3 rounded-xl bg-muted p-4" data-testid="dashboard-locked-notice">
        <Lock className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
        <div><p className="text-sm font-bold">{t("locked_title")}</p><p className="text-xs text-muted-foreground">{t("locked_desc")}</p></div>
      </div>
    </div>
  );
};
